export interface ValueChange<T> {
  oldValue: T;
  newValue: T;
}

export const buildValueChange = <T>(
  oldValue: T,
  newValue: T
): ValueChange<T> | undefined => {
  if (oldValue === newValue) {
    return undefined;
  }
  return {
    oldValue,
    newValue,
  };
};
